import React from 'react';

import Actions from './actions';
import Logo from './logo';

const Header = () => {
  return (
    <div className="header">
      <Logo />
      <Actions />
    </div>
  );
};

export default Header;
